import styled from 'styled-components'

export const Options = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 5px;
`

export const Option = styled.div`
  width: 100%;
  height: 60px;
  padding: 5px;
  border-radius: 10px;
  cursor: pointer;
  background: rgb(209, 209, 209);
  opacity: 0.5;

  &:hover {
    opacity: 1;
  }

  p {
    all: unset;
    font-size: 13px;
  }
`
